import { Component, OnInit } from '@angular/core';
import { FooterComponent } from '../../../common-components/footer/footer.component';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../../../common-components/header/header.component';

@Component({
    selector: 'app-quote-calculation',
    templateUrl: './quote-calculation.component.html',
    styleUrls: ['./quote-calculation.component.scss'],
    imports: [HeaderComponent, RouterOutlet, FooterComponent]
})
export class QuoteCalculationComponent {

  constructor() { }


}
